<template>
    <div>
        <transition name="fade">
            <div v-if="visible" class="tw-fixed tw-z-[10001] tw-top-0 tw-left-0 tw-w-full tw-h-screen tw-bg-white tw-grid tw-grid-cols-1 lg:tw-grid-cols-2">
                <!-- Left side -->
                <div class="tw-h-full tw-relative tw-hidden lg:tw-block">
                    <div
                        v-if="authbox && authbox.Picture"
                        :style="{ backgroundImage: `url('/file/${authbox.Picture}')` }"
                        class="tw-absolute tw-z-10 tw-top-0 tw-left-0 tw-w-full tw-h-full tw-bg-cover tw-bg-center"
                    ></div>
                    <div v-if="authbox" class="tw-absolute tw-top-0 tw-left-0 tw-w-full tw-h-full tw-z-20 tw-p-12">
                        <div class="tw-text-4xl tw-text-gray-800 tw-font-bold tw-mb-8 tw-max-w-sm">
                            {{ authbox.Name }}
                        </div>
                        <div v-html="authbox.Content" class="tw-text-gray-600 tw-text-xl tw-max-w-sm"></div>
                    </div>
                    <img
                        v-if="settings.LogoWhite"
                        :src="`/file/${settings.LogoWhite}`"
                        :alt="`Logo ${settings.Name}`"
                        class="tw-absolute tw-bottom-8 tw-left-8 tw-h-8 tw-z-30"
                    />
                </div>

                <!-- Right side -->
                <div class="tw-bg-gray-100 tw-overflow-x-hidden">
                    <div class="tw-px-4 tw-py-24 lg:tw-p-16 tw-h-screen tw-relative tw-overflow-y-auto tw-overflow-x-hidden">
                        <!-- Close button -->
                        <div
                            class="tw-fixed lg:tw-absolute tw-z-40 tw-top-0 tw-px-4 tw-left-0 tw-py-4 tw-w-full tw-flex tw-items-center tw-justify-between tw-bg-primary lg:tw-bg-transparent"
                        >
                            <img
                                v-if="settings.LogoWhite"
                                :src="`/file/${settings.LogoWhite}`"
                                :alt="`Logo ${settings.Name}`"
                                class="tw-h-6 tw-block lg:tw-hidden"
                            />
                            <div class="tw-flex-grow tw-hidden lg:tw-block"></div>
                            <button
                                class="tw-border-none tw-outline-none  tw-bg-transparent tw-text-white lg:tw-text-gray-400 tw-ring-0 tw-transition-all tw-duration-300 tw-ease-in-out hover:tw-text-red-500 focus:tw-outline-none focus:tw-border-none"
                                @click="closeDialog"
                            >
                                <svg xmlns="http://www.w3.org/2000/svg" class="tw-h-8 tw-w-8" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
                                </svg>
                            </button>
                        </div>

                        <!-- Tab buttons -->
                        <div class="tw-flex tw-space-x-8 tw-mb-12">
                            <div
                                class="tw-text-xl tw-font-bold  tw-cursor-pointer tw-transition-all tw-duration-300 tw-ease-in-out hover:tw-text-gray-600 tw-select-none"
                                :class="{
                                    'tw-text-gray-800': tab === 'register',
                                    'tw-text-gray-400': tab !== 'register',
                                }"
                                @click="tab = 'register'"
                            >
                                Zarejestruj się
                            </div>
                            <div
                                class="tw-text-xl tw-font-bold tw-cursor-pointer tw-transition-all tw-duration-300 tw-ease-in-out hover:tw-text-gray-600 tw-select-none"
                                :class="{ 'tw-text-gray-800': tab === 'login', 'tw-text-gray-400': tab !== 'login' }"
                                @click="tab = 'login'"
                            >
                                Zaloguj się
                            </div>
                        </div>

                        <!-- Tabs -->
                        <div class="tw-relative">
                            <transition-group name="movex">
                                <!-- Register -->
                                <div v-if="tab === 'register'" key="tab0" class="tw-w-full">
                                    <a
                                        class="tw-flex tw-rounded-lg tw-border-2 tw-border-primary tw-border-solid tw-text-primary tw-relative tw-h-14 tw-items-center tw-justify-center tw-mb-2 tw-transition-all tw-duration-300 tw-ease-in-out tw-select-none hover:tw-bg-primary hover:tw-text-white"
                                        :href="googleClientAuthUrl"
                                    >
                                        <svg class="tw-h-7 tw-w-7 tw-absolute tw-left-4 tw-top-3" viewBox="0 0 24 24" stroke="currentColor" fill="currentColor">
                                            <path
                                                d="M21.35,11.1H12.18V13.83H18.69C18.36,17.64 15.19,19.27 12.19,19.27C8.36,19.27 5,16.25 5,12C5,7.9 8.2,4.73 12.2,4.73C15.29,4.73 17.1,6.7 17.1,6.7L19,4.72C19,4.72 16.56,2 12.1,2C6.42,2 2.03,6.8 2.03,12C2.03,17.05 6.16,22 12.25,22C17.6,22 21.5,18.33 21.5,12.91C21.5,11.76 21.35,11.1 21.35,11.1V11.1Z"
                                            />
                                        </svg>
                                        <span class="tw-font-bold">Kontynuuj przez Google</span>
                                    </a>
                                    <a
                                        :href="
                                            `https://www.facebook.com/v11.0/dialog/oauth?client_id=${config.facebookAppId}&redirect_uri=${facebookLoginUri}&scope=email`
                                        "
                                        class="tw-flex tw-rounded-lg tw-border-2 tw-border-primary tw-border-solid tw-text-primary tw-relative tw-h-14 tw-items-center tw-justify-center tw-mb-8 tw-transition-all tw-duration-300 tw-ease-in-out tw-select-none hover:tw-bg-primary hover:tw-text-white"
                                    >
                                        <svg class="tw-h-6 tw-w-6 tw-absolute tw-left-4 tw-top-4" viewBox="0 0 24 24" fill="currentColor">
                                            <path
                                                d="M9 8h-3v4h3v12h5v-12h3.642l.358-4h-4v-1.667c0-.955.192-1.333 1.115-1.333h2.885v-5h-3.808c-3.596 0-5.192 1.583-5.192 4.615v3.385z"
                                            />
                                        </svg>
                                        <span class="tw-font-bold">Kontynuuj przez Facebook</span>
                                    </a>
                                    <div class="text-center mb-4 tw-font-bold">lub przez formularz</div>
                                    <form method="POST" @submit.prevent="register">
                                        <div class="tw-mb-6">
                                            <label
                                                for="registerUsername"
                                                class="tw-text-xs tw-font-semibold tw-uppercase tw-leading-none tw-text-gray-400 tw-tracking-wider tw-mb-0"
                                                >Nazwa użytkownika</label
                                            >
                                            <input
                                                v-model="registerForm.RegisterUsername"
                                                :disabled="isRegister"
                                                id="registerUsername"
                                                type="text"
                                                required
                                                placeholder="wpisz swoją nazwę użytkownika"
                                                class="tw-h-10 tw-placeholder-gray-300 tw-bg-transparent tw-w-full tw-border-solid tw-border-0 tw-border-b-2 tw-border-gray-800 focus:tw-border-success focus:tw-outline-none disabled:tw-text-gray-500 tw-rounded-none tw-px-0"
                                            />
                                            <div v-if="registerErrors.RegisterUsername" class="tw-text-sm tw-text-red-600 mt-1">
                                                {{ Object.values(registerErrors.RegisterUsername)[0] }}
                                            </div>
                                        </div>
                                        <div class="tw-mb-6">
                                            <label
                                                for="registerEmail"
                                                class="tw-text-xs tw-font-semibold tw-uppercase tw-leading-none tw-text-gray-400 tw-tracking-wider tw-mb-0"
                                                >E-mail</label
                                            >
                                            <input
                                                v-model="registerForm.RegisterEmail"
                                                :disabled="isRegister"
                                                id="registerEmail"
                                                type="email"
                                                required
                                                placeholder="wpisz swój adres e-mail"
                                                class="tw-h-10 tw-placeholder-gray-300 tw-bg-transparent tw-w-full tw-border-solid tw-border-0 tw-border-b-2 tw-border-gray-800 focus:tw-border-success focus:tw-outline-none disabled:tw-text-gray-500 tw-rounded-none tw-px-0"
                                            />
                                            <div v-if="registerErrors.RegisterEmail" class="tw-text-sm tw-text-red-600 mt-1">
                                                {{ Object.values(registerErrors.RegisterEmail)[0] }}
                                            </div>
                                        </div>
                                        <div class="tw-mb-8">
                                            <label
                                                for="RegisterPassword"
                                                class="tw-text-xs tw-font-semibold tw-uppercase tw-leading-none tw-text-gray-400 tw-tracking-wider tw-mb-0"
                                                >Hasło</label
                                            >
                                            <div class="tw-relative">
                                                <input
                                                    v-model="registerForm.RegisterPassword"
                                                    :disabled="isRegister"
                                                    id="RegisterPassword"
                                                    :type="showRegisterPassword ? 'text' : 'password'"
                                                    required
                                                    placeholder="wpisz swoje hasło"
                                                    class="tw-h-10 tw-placeholder-gray-300 tw-bg-transparent tw-w-full tw-border-solid tw-border-0 tw-border-b-2 tw-border-gray-800 focus:tw-border-success focus:tw-outline-none disabled:tw-text-gray-500 tw-rounded-none tw-pl-0 tw-pr-8"
                                                />
                                                <button
                                                    type="button"
                                                    class="tw-bg-none tw-bg-transparent tw-border-none tw-outline-none tw-absolute tw-top-1 tw-right-0 tw-block focus:tw-outline-none"
                                                    @click="showRegisterPassword = !showRegisterPassword"
                                                >
                                                    <svg
                                                        v-if="!showRegisterPassword"
                                                        xmlns="http://www.w3.org/2000/svg"
                                                        class="tw-h-6 tw-w-6 tw-text-red-600"
                                                        fill="none"
                                                        viewBox="0 0 24 24"
                                                        stroke="currentColor"
                                                    >
                                                        <path
                                                            stroke-linecap="round"
                                                            stroke-linejoin="round"
                                                            stroke-width="2"
                                                            d="M13.875 18.825A10.05 10.05 0 0112 19c-4.478 0-8.268-2.943-9.543-7a9.97 9.97 0 011.563-3.029m5.858.908a3 3 0 114.243 4.243M9.878 9.878l4.242 4.242M9.88 9.88l-3.29-3.29m7.532 7.532l3.29 3.29M3 3l3.59 3.59m0 0A9.953 9.953 0 0112 5c4.478 0 8.268 2.943 9.543 7a10.025 10.025 0 01-4.132 5.411m0 0L21 21"
                                                        />
                                                    </svg>
                                                    <svg
                                                        v-else
                                                        xmlns="http://www.w3.org/2000/svg"
                                                        class="tw-h-6 tw-w-6 tw-text-success"
                                                        fill="none"
                                                        viewBox="0 0 24 24"
                                                        stroke="currentColor"
                                                    >
                                                        <path
                                                            stroke-linecap="round"
                                                            stroke-linejoin="round"
                                                            stroke-width="2"
                                                            d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"
                                                        />
                                                        <path
                                                            stroke-linecap="round"
                                                            stroke-linejoin="round"
                                                            stroke-width="2"
                                                            d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"
                                                        />
                                                    </svg>
                                                </button>
                                                <div v-if="registerErrors.RegisterPassword" class="tw-text-sm tw-text-red-600 mt-1">
                                                    {{ Object.values(registerErrors.RegisterPassword)[0] }}
                                                </div>
                                            </div>
                                        </div>
                                        <div class="tw-mb-4 ">
                                            <div class="tw-flex">
                                                <input
                                                    v-model="registerForm.RegisterIsAccepts"
                                                    type="checkbox"
                                                    :disabled="isRegister"
                                                    required
                                                    true-value="1"
                                                    false-value="0"
                                                    id="RegisterIsAccepts"
                                                    class="tw-flex-shrink-0 tw-w-5 tw-h-5 tw-rounded-sm tw-mr-3"
                                                />
                                                <label for="RegisterIsAccepts" class="tw-leading-tight tw-text-gray-700"
                                                    >Akceptuję
                                                    <a :href="regulationsLink" target="_blank" class="tw-font-bold tw-text-primary">regulamin</a>
                                                    oraz
                                                    <a :href="cookiesLink" target="_blank" class="tw-font-bold tw-text-primary">politykę prywatności</a>
                                                    serwisu <span class="tw-font-bold">Język w 15 minut</span></label
                                                >
                                            </div>

                                            <div v-if="registerErrors.RegisterIsAccepts" class="tw-text-sm tw-text-red-600 mt-1">
                                                {{ Object.values(registerErrors.RegisterIsAccepts)[0] }}
                                            </div>
                                        </div>
                                        <input type="hidden" v-model="recaptchaToken" />
                                        <div class="tw-flex tw-h-8 tw-text-xs tw-text-red-500 tw-mb-2">
                                            {{ registerError }}
                                        </div>

                                        <button
                                            type="submit"
                                            :disabled="isRegister"
                                            class="tw-flex tw-border-none tw-bg-success tw-text-white tw-text-center tw-font-bold tw-h-14 tw-w-full tw-items-center tw-justify-center tw-rounded-lg tw-transition-all tw-duration-300 tw-ease-in-out hover:tw-bg-opacity-75 focus:tw-outline-none focus:tw-ring-2 focus:tw-ring-success focus:tw-ring-opacity-50 disabled:tw-bg-opacity-75"
                                        >
                                            <svg
                                                v-if="isRegister"
                                                xmlns="http://www.w3.org/2000/svg"
                                                viewBox="0 0 24 24"
                                                fill="currentColor"
                                                class="tw-w-6 tw-h-6 tw-animate-spin"
                                            >
                                                <path
                                                    d="M12 0c-6.627 0-12 5.373-12 12s5.373 12 12 12 12-5.373 12-12-5.373-12-12-12zm8 12c0 4.418-3.582 8-8 8s-8-3.582-8-8 3.582-8 8-8 8 3.582 8 8zm-19 0c0-6.065 4.935-11 11-11v2c-4.962 0-9 4.038-9 9 0 2.481 1.009 4.731 2.639 6.361l-1.414 1.414.015.014c-2-1.994-3.24-4.749-3.24-7.789z"
                                                />
                                            </svg>
                                            <span v-else class="tw-uppercase tw-tracking-widest">zarejestruj się</span>
                                        </button>
                                    </form>
                                </div>

                                <!-- Login -->
                                <div v-if="tab === 'login'" key="tab1" class="tw-w-full">
                                    <a
                                        class="tw-flex tw-rounded-lg tw-border-2 tw-border-primary tw-border-solid tw-text-primary tw-relative tw-h-14 tw-items-center tw-justify-center tw-mb-2 tw-transition-all tw-duration-300 tw-ease-in-out tw-select-none hover:tw-bg-primary hover:tw-text-white"
                                        :href="googleClientAuthUrl"
                                    >
                                        <svg class="tw-h-7 tw-w-7 tw-absolute tw-left-4 tw-top-3" viewBox="0 0 24 24" stroke="currentColor" fill="currentColor">
                                            <path
                                                d="M21.35,11.1H12.18V13.83H18.69C18.36,17.64 15.19,19.27 12.19,19.27C8.36,19.27 5,16.25 5,12C5,7.9 8.2,4.73 12.2,4.73C15.29,4.73 17.1,6.7 17.1,6.7L19,4.72C19,4.72 16.56,2 12.1,2C6.42,2 2.03,6.8 2.03,12C2.03,17.05 6.16,22 12.25,22C17.6,22 21.5,18.33 21.5,12.91C21.5,11.76 21.35,11.1 21.35,11.1V11.1Z"
                                            />
                                        </svg>
                                        <span class="tw-font-bold">Zaloguj przez Google</span>
                                    </a>
                                    <a
                                        :href="
                                            `https://www.facebook.com/v11.0/dialog/oauth?client_id=${config.facebookAppId}&redirect_uri=${facebookLoginUri}&scope=email`
                                        "
                                        class="tw-flex tw-rounded-lg tw-border-2 tw-border-primary tw-border-solid tw-text-primary tw-relative tw-h-14 tw-items-center tw-justify-center tw-mb-8 tw-transition-all tw-duration-300 tw-ease-in-out tw-select-none hover:tw-bg-primary hover:tw-text-white"
                                    >
                                        <svg class="tw-h-6 tw-w-6 tw-absolute tw-left-4 tw-top-4" viewBox="0 0 24 24" fill="currentColor">
                                            <path
                                                d="M9 8h-3v4h3v12h5v-12h3.642l.358-4h-4v-1.667c0-.955.192-1.333 1.115-1.333h2.885v-5h-3.808c-3.596 0-5.192 1.583-5.192 4.615v3.385z"
                                            />
                                        </svg>
                                        <span class="tw-font-bold">Zaloguj przez Facebook</span>
                                    </a>
                                    <div class="text-center tw-mb-12 tw-font-bold">lub przez formularz</div>

                                    <div
                                        v-if="registerComplete"
                                        ref="registerComplete"
                                        class="tw-bg-success tw-text-white tw-px-8 tw-py-4 tw-rounded tw-mb-8 tw-flex tw-items-center"
                                    >
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            class="tw-h-7 tw-w-7 tw-flex-shrink-0 tw-mr-3"
                                            fill="none"
                                            viewBox="0 0 24 24"
                                            stroke="currentColor"
                                        >
                                            <path
                                                stroke-linecap="round"
                                                stroke-linejoin="round"
                                                stroke-width="2"
                                                d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
                                            />
                                        </svg>
                                        <span>Konto zostało założone. Możesz się teraz zalogować</span>
                                    </div>
                                    <div
                                        v-if="restoreComplete"
                                        ref="restoreComplete"
                                        class="tw-bg-success tw-text-white tw-px-8 tw-py-4 tw-rounded tw-mb-8 tw-flex tw-items-center"
                                    >
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            class="tw-h-7 tw-w-7 tw-flex-shrink-0 tw-mr-3"
                                            fill="none"
                                            viewBox="0 0 24 24"
                                            stroke="currentColor"
                                        >
                                            <path
                                                stroke-linecap="round"
                                                stroke-linejoin="round"
                                                stroke-width="2"
                                                d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
                                            />
                                        </svg>
                                        <span>Hasło zostało zmienione. Możesz się teraz zalogować</span>
                                    </div>

                                    <form method="POST" @submit.prevent="login">
                                        <div class="tw-mb-6">
                                            <label
                                                for="LoginUsername"
                                                class="tw-text-xs tw-font-semibold tw-uppercase tw-leading-none tw-text-gray-400 tw-tracking-wider tw-mb-0"
                                                >Nazwa użytkownika lub E-mail</label
                                            >
                                            <input
                                                v-model="loginForm.LoginUsername"
                                                :disabled="isLogging"
                                                id="LoginUsername"
                                                type="text"
                                                required
                                                placeholder="wpisz swoją nazwę użytkownika"
                                                class="tw-h-10 tw-placeholder-gray-300 tw-bg-transparent tw-w-full tw-border-solid tw-border-0 tw-border-b-2 tw-border-gray-800 focus:tw-border-success focus:tw-outline-none disabled:tw-text-gray-500 tw-rounded-none tw-px-0"
                                            />
                                        </div>
                                        <div class="tw-mb-4">
                                            <label
                                                for="LoginPassword"
                                                class="tw-text-xs tw-font-semibold tw-uppercase tw-leading-none tw-text-gray-400 tw-tracking-wider tw-mb-0"
                                                >Hasło</label
                                            >
                                            <div class="tw-relative">
                                                <input
                                                    v-model="loginForm.LoginPassword"
                                                    :disabled="isLogging"
                                                    id="LoginPassword"
                                                    :type="showLoginPassword ? 'text' : 'password'"
                                                    required
                                                    placeholder="wpisz swoje hasło"
                                                    class="tw-h-10 tw-placeholder-gray-300 tw-bg-transparent tw-w-full tw-border-solid tw-border-0 tw-border-b-2 tw-border-gray-800 focus:tw-border-success focus:tw-outline-none disabled:tw-text-gray-500 tw-rounded-none tw-pl-0 tw-pr-8"
                                                />
                                                <button
                                                    type="button"
                                                    class="tw-bg-none tw-bg-transparent tw-border-none tw-outline-none tw-absolute tw-top-1 tw-right-0 tw-block focus:tw-outline-none"
                                                    @click="showLoginPassword = !showLoginPassword"
                                                >
                                                    <svg
                                                        v-if="!showLoginPassword"
                                                        xmlns="http://www.w3.org/2000/svg"
                                                        class="tw-h-6 tw-w-6 tw-text-red-600"
                                                        fill="none"
                                                        viewBox="0 0 24 24"
                                                        stroke="currentColor"
                                                    >
                                                        <path
                                                            stroke-linecap="round"
                                                            stroke-linejoin="round"
                                                            stroke-width="2"
                                                            d="M13.875 18.825A10.05 10.05 0 0112 19c-4.478 0-8.268-2.943-9.543-7a9.97 9.97 0 011.563-3.029m5.858.908a3 3 0 114.243 4.243M9.878 9.878l4.242 4.242M9.88 9.88l-3.29-3.29m7.532 7.532l3.29 3.29M3 3l3.59 3.59m0 0A9.953 9.953 0 0112 5c4.478 0 8.268 2.943 9.543 7a10.025 10.025 0 01-4.132 5.411m0 0L21 21"
                                                        />
                                                    </svg>
                                                    <svg
                                                        v-else
                                                        xmlns="http://www.w3.org/2000/svg"
                                                        class="tw-h-6 tw-w-6 tw-text-success"
                                                        fill="none"
                                                        viewBox="0 0 24 24"
                                                        stroke="currentColor"
                                                    >
                                                        <path
                                                            stroke-linecap="round"
                                                            stroke-linejoin="round"
                                                            stroke-width="2"
                                                            d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"
                                                        />
                                                        <path
                                                            stroke-linecap="round"
                                                            stroke-linejoin="round"
                                                            stroke-width="2"
                                                            d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"
                                                        />
                                                    </svg>
                                                </button>
                                            </div>
                                            <div class="tw-text-xs tw-text-primary tw-text-right tw-py-1">
                                                <div class="tw-inline-block tw-cursor-pointer hover:tw-underline" @click="tab = 'restore'">
                                                    Nie pamiętam hasła
                                                </div>
                                            </div>
                                        </div>
                                        <div class="tw-flex tw-h-8 tw-text-xs tw-text-red-500 tw-mb-2">
                                            {{ loginError }}
                                        </div>
                                        <button
                                            type="submit"
                                            :disabled="isLogging"
                                            class="tw-flex tw-border-none tw-bg-success tw-text-white tw-text-center tw-font-bold tw-h-14 tw-w-full tw-items-center tw-justify-center tw-rounded-lg tw-transition-all tw-duration-300 tw-ease-in-out hover:tw-bg-opacity-75 focus:tw-outline-none focus:tw-ring-2 focus:tw-ring-success focus:tw-ring-opacity-50 disabled:tw-bg-opacity-75"
                                        >
                                            <svg
                                                v-if="isLogging"
                                                xmlns="http://www.w3.org/2000/svg"
                                                viewBox="0 0 24 24"
                                                fill="currentColor"
                                                class="tw-w-6 tw-h-6 tw-animate-spin"
                                            >
                                                <path
                                                    d="M12 0c-6.627 0-12 5.373-12 12s5.373 12 12 12 12-5.373 12-12-5.373-12-12-12zm8 12c0 4.418-3.582 8-8 8s-8-3.582-8-8 3.582-8 8-8 8 3.582 8 8zm-19 0c0-6.065 4.935-11 11-11v2c-4.962 0-9 4.038-9 9 0 2.481 1.009 4.731 2.639 6.361l-1.414 1.414.015.014c-2-1.994-3.24-4.749-3.24-7.789z"
                                                />
                                            </svg>
                                            <span v-else class="tw-uppercase tw-tracking-widest">zaloguj się</span>
                                        </button>
                                    </form>
                                </div>
                                <!-- Restore -->
                                <div v-if="tab === 'restore'" key="tab2" class="tw-w-full">
                                    <form method="POST" @submit.prevent="sendRestoreCode" v-if="!restoreCodeSent">
                                        <div class="tw-mb-6">
                                            <label
                                                for="RestoreUsername"
                                                class="tw-text-xs tw-font-semibold tw-uppercase tw-leading-none tw-text-gray-400 tw-tracking-wider tw-mb-0"
                                                >Nazwa użytkownika lub E-mail</label
                                            >
                                            <input
                                                v-model="restoreForm.Username"
                                                :disabled="isRestoring"
                                                id="RestoreUsername"
                                                type="text"
                                                required
                                                placeholder="wpisz swoją nazwę użytkownika"
                                                class="tw-h-10 tw-placeholder-gray-300 tw-bg-transparent tw-w-full tw-border-solid tw-border-0 tw-border-b-2 tw-border-gray-800 focus:tw-border-success focus:tw-outline-none disabled:tw-text-gray-500 tw-rounded-none tw-px-0"
                                            />
                                        </div>
                                        <div class="tw-mb-6">
                                            <label
                                                for="RestorePassword"
                                                class="tw-text-xs tw-font-semibold tw-uppercase tw-leading-none tw-text-gray-400 tw-tracking-wider tw-mb-0"
                                                >Nowe hasło</label
                                            >
                                            <input
                                                v-model="restoreForm.Password"
                                                :disabled="isRestoring"
                                                id="RestorePassword"
                                                type="password"
                                                required
                                                placeholder="wpisz nowe hasło"
                                                class="tw-h-10 tw-placeholder-gray-300 tw-bg-transparent tw-w-full tw-border-solid tw-border-0 tw-border-b-2 tw-border-gray-800 focus:tw-border-success focus:tw-outline-none disabled:tw-text-gray-500 tw-rounded-none tw-px-0"
                                            />
                                            <div v-if="restoreErrors && restoreErrors.Password" class="tw-text-xs tw-line-clamp-1 tw-text-red-600 tw-mt-1">
                                                {{ restoreErrors.Password[Object.keys(restoreErrors.Password)[0]] }}
                                            </div>
                                        </div>
                                        <div class="tw-mb-12">
                                            <label
                                                for="RestorePassword"
                                                class="tw-text-xs tw-font-semibold tw-uppercase tw-leading-none tw-text-gray-400 tw-tracking-wider tw-mb-0"
                                                >Powtórz nowe hasło</label
                                            >
                                            <input
                                                v-model="restoreForm.PasswordRepeat"
                                                :disabled="isRestoring"
                                                id="RestorePasswordRepeat"
                                                type="password"
                                                required
                                                placeholder="wpisz ponownie nowe hasło"
                                                class="tw-h-10 tw-placeholder-gray-300 tw-bg-transparent tw-w-full tw-border-solid tw-border-0 tw-border-b-2 tw-border-gray-800 focus:tw-border-success focus:tw-outline-none disabled:tw-text-gray-500 tw-rounded-none tw-px-0"
                                            />
                                            <div
                                                v-if="restoreErrors && restoreErrors.PasswordRepeat"
                                                class="tw-text-xs tw-line-clamp-1 tw-text-red-600 tw-mt-1"
                                            >
                                                {{ restoreErrors.PasswordRepeat[Object.keys(restoreErrors.PasswordRepeat)[0]] }}
                                            </div>
                                        </div>

                                        <button
                                            type="submit"
                                            :disabled="isRestoring"
                                            class="tw-flex tw-border-none tw-bg-success tw-text-white tw-text-center tw-font-bold tw-h-14 tw-w-full tw-items-center tw-justify-center tw-rounded-lg tw-transition-all tw-duration-300 tw-ease-in-out hover:tw-bg-opacity-75 focus:tw-outline-none focus:tw-ring-2 focus:tw-ring-success focus:tw-ring-opacity-50 disabled:tw-bg-opacity-75"
                                        >
                                            <svg
                                                v-if="isRestoring"
                                                xmlns="http://www.w3.org/2000/svg"
                                                viewBox="0 0 24 24"
                                                fill="currentColor"
                                                class="tw-w-6 tw-h-6 tw-animate-spin"
                                            >
                                                <path
                                                    d="M12 0c-6.627 0-12 5.373-12 12s5.373 12 12 12 12-5.373 12-12-5.373-12-12-12zm8 12c0 4.418-3.582 8-8 8s-8-3.582-8-8 3.582-8 8-8 8 3.582 8 8zm-19 0c0-6.065 4.935-11 11-11v2c-4.962 0-9 4.038-9 9 0 2.481 1.009 4.731 2.639 6.361l-1.414 1.414.015.014c-2-1.994-3.24-4.749-3.24-7.789z"
                                                />
                                            </svg>
                                            <span v-else class="tw-uppercase tw-tracking-widest">zmień hasło</span>
                                        </button>
                                        <div class="tw-block tw-text-xs tw-text-red-500 tw-mb-2 tw-mt-4 tw-text-center">
                                            {{ restoreError }}
                                        </div>
                                    </form>
                                    <form method="POST" @submit.prevent="restore" v-else>
                                        <div class="tw-mb-6">
                                            <label
                                                for="RestoreUsername"
                                                class="tw-text-xs tw-font-semibold tw-uppercase tw-leading-none tw-text-gray-400 tw-tracking-wider tw-mb-0"
                                                >Kod E-mail</label
                                            >
                                            <input
                                                v-model="restoreForm.Code"
                                                :disabled="isRestoring"
                                                id="RestoreUsername"
                                                type="text"
                                                required
                                                placeholder="wpisz kod przesłany na adres e-mail"
                                                class="tw-h-10 tw-placeholder-gray-300 tw-bg-transparent tw-w-full tw-border-solid tw-border-0 tw-border-b-2 tw-border-gray-800 focus:tw-border-success focus:tw-outline-none disabled:tw-text-gray-500 tw-rounded-none"
                                            />
                                        </div>
                                        <button
                                            type="submit"
                                            :disabled="isRestoring"
                                            class="tw-flex tw-border-none tw-bg-success tw-text-white tw-text-center tw-font-bold tw-h-14 tw-w-full tw-items-center tw-justify-center tw-rounded-lg tw-transition-all tw-duration-300 tw-ease-in-out hover:tw-bg-opacity-75 focus:tw-outline-none focus:tw-ring-2 focus:tw-ring-success focus:tw-ring-opacity-50 disabled:tw-bg-opacity-75"
                                        >
                                            <svg
                                                v-if="isRestoring"
                                                xmlns="http://www.w3.org/2000/svg"
                                                viewBox="0 0 24 24"
                                                fill="currentColor"
                                                class="tw-w-6 tw-h-6 tw-animate-spin"
                                            >
                                                <path
                                                    d="M12 0c-6.627 0-12 5.373-12 12s5.373 12 12 12 12-5.373 12-12-5.373-12-12-12zm8 12c0 4.418-3.582 8-8 8s-8-3.582-8-8 3.582-8 8-8 8 3.582 8 8zm-19 0c0-6.065 4.935-11 11-11v2c-4.962 0-9 4.038-9 9 0 2.481 1.009 4.731 2.639 6.361l-1.414 1.414.015.014c-2-1.994-3.24-4.749-3.24-7.789z"
                                                />
                                            </svg>
                                            <span v-else class="tw-uppercase tw-tracking-widest">potwierdzam hasło</span>
                                        </button>
                                        <div class="text-center tw-mt-2">
                                            <div
                                                class="tw-inline-block tw-cursor-pointer tw-text-sm tw-text-primary hover:tw-underline"
                                                @click="resetRestoreProcess"
                                            >
                                                Od początku
                                            </div>
                                        </div>
                                        <div class="tw-block tw-text-xs tw-text-red-500 tw-mb-2 tw-mt-4 tw-text-center">
                                            {{ restoreError }}
                                        </div>
                                    </form>
                                </div>
                            </transition-group>
                        </div>
                    </div>
                </div>
            </div>
        </transition>
    </div>
</template>

<script>
    import EventBus from '../eventBus.js'
    export default {
        name: 'AuthDialog',
        props: ['settings', 'authbox', 'googleClientAuthUrl', 'config', 'regulationsLink', 'cookiesLink', 'routeLang'],
        data() {
            return {
                visible: false,
                tab: 'login',
                facebookLoginUri: encodeURI(this.config.facebookRedirectUri + '/logowanie-facebook'),
                isLogging: false,
                isRegister: false,
                loginForm: {
                    LoginUsername: '',
                    LoginPassword: '',
                },
                registerForm: {
                    RegisterUsername: '',
                    RegisterPassword: '',
                    RegisterEmail: '',
                    RegisterIsNewsletter: '1',
                    RegisterIsAccepts: '0',
                    RegisterRef: '',
                },
                restoreForm: {
                    Username: '',
                    Password: '',
                    PasswordRepeat: '',
                    Code: '',
                },
                isRestoring: false,
                recaptchaToken: '',
                loginError: null,
                registerError: null,
                registerComplete: false,
                restoreError: null,
                restoreErrors: [],
                restoreCodeSent: false,
                restoreComplete: false,
                showLoginPassword: false,
                showRegisterPassword: false,
                showRegisterRepeatPassword: false,
                registerErrors: [],
            }
        },
        watch: {
            visible(val) {
                var body = document.body
                if (val) {
                    body.classList.add('tw-h-full', 'tw-overflow-hidden')
                } else {
                    body.classList.remove('tw-h-full', 'tw-overflow-hidden')
                }
            },
        },
        methods: {
            async login() {
                if (!this.isLogging) {
                    this.isLogging = true
                    const formData = new FormData()
                    formData.append('LoginUsername', this.loginForm.LoginUsername)
                    formData.append('LoginPassword', this.loginForm.LoginPassword)
                    formData.append('Lang', this.routeLang)
                    const { data } = await this.$http.post('/logowanie', formData, {
                        headers: {
                            'content-type': 'application/x-www-form-urlencoded',
                        },
                    })
                    if (!data.isError) {
                        const url = window.location.protocol + '//' + window.location.host
                        window.location.replace(url)
                    } else {
                        this.loginError = data.messages
                        this.isLogging = false
                    }
                }
            },
            async register() {
                if (!this.isRegister) {
                    this.isRegister = true
                    const formData = new FormData()
                    formData.append('RegisterUsername', this.registerForm.RegisterUsername)
                    formData.append('RegisterEmail', this.registerForm.RegisterEmail)
                    formData.append('RegisterPassword', this.registerForm.RegisterPassword)
                    formData.append('RegisterIsNewsletter', this.registerForm.RegisterIsNewsletter)
                    formData.append('RegisterIsAccepts', this.registerForm.RegisterIsAccepts)
                    formData.append('RegisterRef', this.registerForm.RegisterRef)
                    formData.append('recaptcha-token', this.recaptchaToken)
                    const { data } = await this.$http.post('/rejestracja', formData, {
                        headers: {
                            'content-type': 'application/x-www-form-urlencoded',
                        },
                    })
                    if (!data.isError) {
                        this.registerErrors = []
                        this.registerComplete = true
                        this.restoreComplete = false
                        this.tab = 'login'
                        this.resetRegisterForm()
                        await this.$nextTick
                        this.$refs.registerComplete.scrollTop = 0
                    } else {
                        this.registerError = data.messages
                        this.registerErrors = data.errors
                        this.getRecaptchaToken()
                    }
                    this.isRegister = false
                }
            },
            async sendRestoreCode() {
                if (!this.isRestoring) {
                    this.isRestoring = true
                    this.restoreComplete = false
                    const formData = new FormData()
                    formData.append('Username', this.restoreForm.Username)
                    formData.append('Password', this.restoreForm.Password)
                    formData.append('PasswordRepeat', this.restoreForm.PasswordRepeat)
                    const { data } = await this.$http.post('/restore-password-code', formData, {
                        headers: {
                            'content-type': 'application/x-www-form-urlencoded',
                        },
                    })
                    if (!data.isError) {
                        this.restoreCodeSent = true
                        this.restoreError = null
                        this.restoreErrors = []
                    } else {
                        this.restoreError = data.messages
                        this.restoreErrors = data.formMessages
                        this.isLogging = false
                    }
                    this.isRestoring = false
                }
            },
            async restore() {
                if (!this.isRestoring) {
                    this.isRestoring = true
                    const formData = new FormData()
                    formData.append('Username', this.restoreForm.Username)
                    formData.append('Code', this.restoreForm.Code)
                    const { data } = await this.$http.post('/restore-password', formData, {
                        headers: {
                            'content-type': 'application/x-www-form-urlencoded',
                        },
                    })
                    if (!data.isError) {
                        this.restoreComplete = true
                        this.registerComplete = false

                        this.tab = 'login'

                        this.resetRestoreProcess()
                    } else {
                        this.restoreError = data.messages
                        this.restoreErrors = data.formMessages
                        this.isLogging = false
                    }
                    this.isRestoring = false
                }
            },
            resetRestoreProcess() {
                this.restoreForm.Username = ''
                this.restoreForm.Password = ''
                this.restoreForm.PasswordRepeat = ''
                this.restoreForm.Code = ''
                this.restoreError = null
                this.restoreErrors = []
                this.restoreCodeSent = false
            },
            resetRegisterForm() {
                this.registerForm.RegisterUsername = ''
                this.registerForm.RegisterEmail = ''
                this.registerForm.RegisterPassword = ''
                this.registerForm.RegisterIsNewsletter = '0'
                this.registerForm.RegisterIsAccepts = '0'
                this.registerForm.RegisterRef = ''
                this.getRecaptchaToken()
            },
            getRecaptchaToken() {
                if (this.config.reCaptcha === 'true' && typeof grecaptcha !== 'undefined') {
                    const _this = this
                    grecaptcha.ready(function() {
                        grecaptcha
                            .execute(_this.config.reCaptchaSiteKey, {
                                action: 'homepage',
                            })
                            .then(function(token) {
                                _this.recaptchaToken = token
                            })
                    })
                }
            },
            openDialog(tab) {
                this.visible = true
                this.tab = tab
            },
            closeDialog() {
                this.visible = false
            },
        },
        created() {
            EventBus.$on('auth:open', this.openDialog)
        },
        mounted() {
            this.getRecaptchaToken()
            let queryParams = new URLSearchParams(window.location.search)
            let ref = queryParams.get('ref')
            if (ref) {
                this.openDialog('register')
                this.registerForm.RegisterRef = ref
            }
        },
    }
</script>

<style></style>
